import { makeStyles } from "tss-react/mui"

export const useStyles = makeStyles()(({ spacing, palette, typography }) => ({
  divider: {
    width: "100%",
    height: "1px",
    background: palette.primary[100]
  },
  button: {
    width: "100%",
    height: "44px",
    borderRadius: 0,
    borderBottomLeftRadius: "12px",
    borderBottomRightRadius: "12px"
  },
  buttonWithCount: {
    "&:hover": {
      backgroundColor: palette.secondary[50],
      color: palette.secondary[700],
      "& .count-badge": {
        backgroundColor: palette.secondary[100]
      }
    }
  },
  countBadge: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    marginLeft: spacing(1),
    minWidth: spacing(5),
    height: spacing(5),
    padding: spacing(0, 0.5),
    borderRadius: "50%",
    backgroundColor: palette.secondary[50],
    fontSize: typography.pxToRem(12),
    fontWeight: typography.fontWeightMedium,
    color: palette.secondary[900],
    lineHeight: 1
  }
}))
